(ns common.db.effects.csv
  (:require [clojure.string :as str]
            [common.util :as util]
            [goog.dom :as gdom]
            [re-frame.core :as rf]))

(defn- sanitize-content [s]
  (str "'" (str/escape s {\" "\"\""
                          \newline "\\n"})))

(defn mapping->header [mapping]
  (map second mapping))

(defn record->row-fn
  "Yields fn giving a mapping that turns record into a collection of strings.

  - Applies column formatter (or str) to non-nil values.
  - Escapes quotes and newlines.
  - Absent/nil values will be empty strings.

  Example:
  ((record->row-fn [[:id \"some label\" inc]
                    [:name \"some other label\"]
                    [:absent \"label\"]])
   {:id 1 :name \"newline \n and \"quotes\"\"})
  ;; => '(\"2\" \"newline \\n and \"\"quotes\"\"\" \"\")
  "
  [mapping]
  (fn [record]
    (for [[key-fn _ format] mapping
          :let [format (or format str)]]
      (-> (key-fn record)
          (some-> format)
          str
          sanitize-content
          util/wrap-with-quotes))))

(defn csv-content
  [rows]
  (->> rows
       (map #(str/join "," %))
       (str/join "\r\n")))

(defn ->csv
  [records mapping]
  (let [data-rows (mapv (record->row-fn mapping) records)
        rows (-> []
                 (conj (mapping->header mapping))
                 (into data-rows))]
    (csv-content rows)))

(defn download-csv
  [csv name]
  (let [filename (str (or name "download") ".csv")
        uri (str "data:text/csv;charset=utf-8,"
                 (js/encodeURIComponent csv))
        tag (gdom/createElement "a")
        props {:href uri :download filename}]
    (gdom/setProperties tag (clj->js props))
    (.click tag)))

(rf/reg-fx :csv/download
  (fn [args]
    (letfn [(download
              ([csv name] (download-csv csv name))
              ([records mapping name] (download-csv (->csv records mapping) name)))]
      (apply download args))))
